import { FC } from "react"
import { Button, Dialog, DialogDescription, DialogHeader, Grid, GridRow, useIntl } from "@metsooutotec/modes-react-components"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"

interface AssetSectionEditorCloseModalProps {
    isOpen: boolean
    setIsOpen: (newValue: boolean) => void
    navigateTo: string
}
const AssetSectionEditorCloseModal: FC<AssetSectionEditorCloseModalProps> = observer(({ isOpen, setIsOpen, navigateTo }) => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const labels = {
        close: formatMessage("assetSectionEditor.close"),
        cancel: formatMessage("assetSectionEditor.cancel"),
        header: formatMessage("assetSectionEditorClose.header"),
        description: formatMessage("assetSectionEditor.description"),
    }
    const onClose = () => {
        setIsOpen(false)
        navigate(navigateTo)
    }
    const onCancle = () => {
        setIsOpen(false)
    }

    const renderButtons = (): React.ReactNode => {
        const buttonsConfig = [
            { label: labels.cancel, onClick: onCancle, primary: false },
            { label: labels.close, onClick: onClose, primary: true },
        ]
        return buttonsConfig.map((button, index) => {
            const { label, onClick, primary } = button
            const buttonGridStyle =
                index === 0
                    ? {
                          marginBottom: "var(--size-m)",
                      }
                    : {}
            return (
                <GridRow key={label} style={buttonGridStyle}>
                    <Button onClick={onClick} flexible={true} children={label} centered size={"medium"} primary={primary} />
                </GridRow>
            )
        })
    }
    return (
        <Grid>
            <Dialog dimmer open={isOpen} size={"small"} style={{ maxWidth: "512px" }}>
                <DialogHeader username={""}>{labels.header}</DialogHeader>
                <DialogDescription style={{ marginBottom: "var(--size-xxl)" }}>{labels.description}</DialogDescription>
                <div style={{ marginBottom: "var(--size-xxl)" }} />
                {renderButtons()}
            </Dialog>
        </Grid>
    )
})

export default AssetSectionEditorCloseModal
